<template>
  <div class="container is-fluid">
    <div class="content content-padding">
      <div class="title-with-selector h1-selector">
        <h1>{{coach ? coach.languages[0].pivot.name : null}}</h1>
        <state-selector :selected="coach ? parseInt(coach.state_id) : null" 
                        :target="coach"
                        :update="'coach'"
        ></state-selector>
      </div>
      <!-- <h1>Características do Coche <span class="tag" :class="coachState.color">{{coachState.text}}</span></h1> -->
      
      <div class="columns">
        <div class="column is-one-quarter">
          <span><b>Nome [PT]</b><br/>{{getCoachNameByLanguage('pt')}}</span>
        </div>
        <div class="column is-one-quarter">
          <span><b>Nome [EN]</b><br/>{{getCoachNameByLanguage('en')}}</span>
        </div>
        <div class="column is-one-quarter">
          <span><b>Nome [ES]</b><br/>{{getCoachNameByLanguage('es')}}</span>
        </div>
        <div class="column is-one-quarter">
          <span><b>Nome [FR]</b><br/>{{getCoachNameByLanguage('fr')}}</span>
        </div>
      </div>

      <div class="columns is-multiline">
        <div class="column is-one-quarter">
          <div>
            <b>Cor de Fundo</b><br/>
            <div class="flex-container-center">
              {{getCoachProperty('background_color')}}
              <div class="color-preview" v-bind:style="{ backgroundColor: getCoachProperty('background_color') }"></div>
            </div>
          </div>
        </div>
        <div class="column is-one-quarter">
          <div>
            <b>Cor de Titulo + Texto do Menu</b><br/>
            <div class="flex-container-center">
              {{getCoachProperty('title_color')}}
              <div class="color-preview" v-bind:style="{ backgroundColor: getCoachProperty('title_color') }"></div>
            </div>
          </div>
        </div>
        <div class="column is-one-quarter">
          <div>
            <b>Cor Botões Inactivos</b><br/>
            <div class="flex-container-center">
              {{getCoachProperty('inactive_color')}}
              <div class="color-preview" v-bind:style="{ backgroundColor: getCoachProperty('inactive_color') }"></div>
            </div>
          </div>
        </div>
        <div class="column is-one-quarter">
          <div>
            <b>Cor Botões Activos</b><br/>
            <div class="flex-container-center">
              {{getCoachProperty('active_color')}}
              <div class="color-preview" v-bind:style="{ backgroundColor: getCoachProperty('active_color') }"></div>
            </div>
          </div>
        </div>
        <div class="column is-one-quarter">
          <div>
            <b>Cor de Separadores do Menu</b><br/>
            <div class="flex-container-center">
              {{getCoachProperty('filet_color')}}
              <div class="color-preview" v-bind:style="{ backgroundColor: getCoachProperty('filet_color') }"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div v-if="coach && coach.background_path"
            class="column is-half">
          <span><b>Background</b></span>
          <figure class="image is-16by9 coach-image">
            <img :src="coachBackground">
          </figure>
        </div>
        <div v-if="coach && coach.foreground_path"
            class="column is-half">
          <span><b>Foreground</b></span>
          <figure class="image is-16by9 coach-image">
            <img :src="coachForeground">
          </figure>
        </div>
      </div>

      <a class="button is-primary" @click="openEditCoachModal">
        <span class="icon">
          <i class="fa fa-edit"></i>
        </span>
        <span>Editar</span>
      </a>
      
    </div>
  </div>
</template>

<script>
  import { COACH_IMG_PATH } from '../../config'
  import Vue from 'vue'
  import CoachEditModal from './CoachEditModal'
  import StateSelector from '../Util/StateSelector'

  const CoachEditModalComponent = Vue.extend(CoachEditModal)

  export default {
    components: {
      StateSelector
    },

    props: ['coach'],

    data () {
      return {
      }
    },

    mounted () {
    },

    computed: {
      currentEvent () {
        return window.store.state.event.nextEvent
      },

      coachState () {
        let stateId = this.getCoachProperty('state_id')
        let text = null
        let color = null

        switch (parseInt(stateId)) {
          case 1:
            text = 'Rascunho'
            color = 'is-danger'
            break
          case 2:
            text = 'Pendente'
            color = 'is-warning'
            break
          case 3:
            text = 'Publicado'
            color = 'is-success'
            break
          case 4:
            text = 'Apagado'
            color = 'is-dark'
            break
          default:
            text = 'Estado desconhecido'
            color = 'is-info'
        }

        return {text: text, color: color}
      },

      coachBackground () {
        return this.getCoachProperty('background_path') ? COACH_IMG_PATH + this.coach.background_path : null
      },

      coachForeground () {
        return this.getCoachProperty('foreground_path') ? COACH_IMG_PATH + this.coach.foreground_path : null
      }
    },

    methods: {
      getCoachNameByLanguage (slug) {
        if (this.coach) {
          for (let lang of this.coach.languages) {
            if (lang.slug === slug) {
              return lang.pivot.name
            }
          }
        }
        return null
      },

      getCoachProperty (property) {
        if (this.coach) {
          return this.coach[property]
        }
        return null
      },

      openEditCoachModal () {
        let openCardModal = (propsData = {}) => {
          return new CoachEditModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        openCardModal({
          title: 'Editar Coche',
          coachData: this.coach
        })
      }
    },

    watch: {
      currentEvent: function (val) {
      }
    }
  }
</script>

<style lang="scss">
  .color-preview {
    height: 15px;
    width: 15px;
    border: 1px solid black;
    margin-left: 5px;
  }

  .coach-image {
    background-image: url("~assets/images/ps-neutral.png") !important;
  }

  .flexbox-grid {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }

  #view-coach .tag {
    margin-top: 4.5px;
  }

  .title-with-selector {
    display: flex;
  }

  .h1-selector .state-selector {
    margin-top: 5px;
    margin-left: 5px;
  }
</style>


// WEBPACK FOOTER //
// CoachInfo.vue?801ece32